import type { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { getMobileBottomSheetPaperRow } from '../../../../styles/mobile-bottom-sheet-paper';

export { getMobileBottomSheetPaperRow };

export const MENU_VIEWPORT_MAX_HEIGHT = `calc(100dvh - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px) - 16px)`;

export const useStyles = makeStyles<{ mode: 'light' | 'dark' }>()(
  (theme, { mode = 'light' }) => ({
    formControl: {
      width: '100%',
      display: 'flex',
      position: 'relative',
      flexDirection: 'row',
      minWidth: 120,
    },
    root: {
      alignItems: 'stretch',
      display: 'flex',
      flexDirection: 'column',
      '& .MuiOutlinedInput-root': {
        height: '44px',
        backgroundColor:
          mode === 'light'
            ? theme.palette.input.main
            : theme.palette.input.dark,
        color: theme.palette.input.contrastText,
        '& fieldset': {
          borderColor: theme.palette.input.dark,
        },
        '&:not(.Mui-disabled):hover fieldset': {
          borderColor: theme.palette.input.dark,
        },
        '&.Mui-focused fieldset': {
          borderColor: theme.palette.primary.main,
        },
        '&.Mui-disabled': {
          backgroundColor: theme.palette.input.disabled,
        },
      },
      '& .MuiInputBase-input::placeholder': {
        color: theme.palette.input.placeholderText,
        opacity: 1,
      },
      '& .MuiSelect-select': {
        color: theme.palette.input.contrastText,
      },
      '& .MuiSelect-icon': {
        color: theme.palette.input.contrastText,
        top: 'calc(50% - 12px)',
      },
      '& .MuiButtonBase-root': {
        padding: 0,
      },
      '&:hover:not(.Mui-disabled) .MuiSvgIcon-root': {
        display: 'block',
      },
      '& .MuiInputBase-root.Mui-disabled .MuiSvgIcon-root': {
        display: 'none',
      },
      '&:hover .Mui-error fieldset': {
        borderColor: `${theme.palette.error.main} !important`,
      },
    },
    label: {
      color: theme.palette.font.secondary,
      lineHeight: 1,
      position: 'static',
      transform: 'none',
      transformOrigin: 'left top',
      fontSize: '1rem',
      marginBottom: theme.spacing(0.5),
      marginLeft: theme.spacing(2),
      '&.Mui-disabled': {
        color: theme.palette.font.disabled,
        opacity: 1,
      },
    },
    closeIcon: {
      '& .MuiSvgIcon-root': {
        width: 16,
        height: 16,
        color: theme.palette.input.contrastText,
        display: 'block',
      },
    },
    labelWithExplaining: {
      marginLeft: theme.spacing(4.5),
    },
    explainingToolTip: {
      '& .MuiSvgIcon-root': {
        color: theme.palette.background.default,
      },
    },
    toolTip: {
      '& .MuiTooltip-tooltip': {
        background: theme.palette.background.paper,
        border: `1px solid ${theme.palette.grey[300]}`,
        boxSizing: 'border-box',
        borderRadius: '10px',
        color: theme.palette.text.primary,
        padding: theme.spacing(2),
      },
    },
    searchField: {
      backgroundColor:
        mode === 'light' ? theme.palette.input.main : theme.palette.input.dark,
      borderRadius: '10px',
      '& .MuiInputBase-input': {
        color: theme.palette.input.contrastText,
      },
      '& .MuiInputBase-input::placeholder': {
        color: theme.palette.input.placeholderText,
        opacity: 1,
      },
      '& .MuiOutlinedInput-root': {
        backgroundColor:
          mode === 'light'
            ? theme.palette.input.main
            : theme.palette.input.dark,
        '& fieldset': {
          borderColor: theme.palette.input.dark,
        },
        '&:hover fieldset': {
          borderColor: theme.palette.input.dark,
        },
        '&.Mui-focused fieldset': {
          borderColor: theme.palette.primary.main,
        },
        '&.Mui-disabled': {
          backgroundColor: theme.palette.input.disabled,
        },
      },
    },
    hidden: {
      display: 'none',
    },
    viewModeWrapper: {
      display: 'flex',
      flexDirection: 'column',
    },

    errorButton: {
      '& svg': {
        color: theme.palette.error.main,
      },
    },
  }),
);

export function getMenuProps(theme: Theme) {
  return {
    autoFocus: false,
    disableScrollLock: true,
    onMouseOver: (e: { stopPropagation: () => void }) => e.stopPropagation(),
    BackdropProps: {
      sx: {
        padding: 0,
        [theme.breakpoints.down('md')]: {
          background: 'rgba(0, 0, 0, 0.3)',
        },
      },
    },
    PaperProps: {
      sx: {
        [theme.breakpoints.down('md')]: {
          ...getMobileBottomSheetPaperRow(),
          '& > ul': {
            paddingTop: 0,
          },
        },
      },
    },
  };
}
